var map = {
	"./config.awstest.json": "+QAq",
	"./config.current.json": "j9f6",
	"./config.dev.json": "nt0N",
	"./config.prod.json": "dm3o",
	"./config.test.json": "d6Aa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pmM0";


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/config\..*\.json$
// module id = pmM0
// module chunks = 3